export const isPermissionRequired = (role, list, mode = PermissionMode.HIDE) => {
    if (!role) return false;
    // Parent Id 0
    if (role['permission_list'][`P${list}`] === mode && mode === PermissionMode.HIDE) {
        return false;
    }
    if (role['permission_list'][`P${list}`] < mode) {
        return false;
    }
    return true;
}

export const allPermissionRequired = (role, list) => {
    if (!role) return true;
    let allTrue = false;
    for (let i = 0; i < list.length; i++) {
        if (list[i].length <= 1) {
            list[i].push(PermissionMode.HIDE);
        }
        if (role['permission_list'][`P${list[i][0]}`] > list[i][1]) {
            allTrue = true;
        }
        if (role['permission_list'][`p${list[i][0]}`] < list[i][1]) {
            allTrue = true;
        }
    }
    return allTrue;
}

export const PermissionMode = {
    HIDE: 0, VIEW: 1, EDIT: 2, CREATE: 3, DEVELOP: 4
}

export const PermissionList = {
    PRICING: 1,
    CART: 2,
    EMAIL_CART: 3,
    EXPORT_CART: 4,
    ARCHIVE_CART: 5,
    RESTORE_CART: 6,
    DELETE_CART: 7,
    CHECKOUT_CART: 8,
    QUOTE: 9,
    EMAIL_QUOTE: 10,
    EXPORT_QUOTE: 11,
    ARCHIVE_QUOTE: 12,
    RESTORE_QUOTE: 13,
    DELETE_QUOTE: 14,
    CONVERT_TO_QUOTE_CART: 15,
    DRILLCART: 16,
    EMAIL_DRILLCART: 17,
    EXPORT_DRILLCART: 18,
    ARCHIVE_DRILLCART: 19,
    RESTORE_DRILLCART: 20,
    DELETE_DRILLCART: 21,
    CONVERT_DRILLCART_TO_CART: 22,
    SUBMITTAL: 23,
    EMAIL_SUBMITTAL: 24,
    EXPORT_SUBMITTAL: 25,
    ARCHIVE_SUBMITTAL: 26,
    RESTORE_SUBMITTAL: 27,
    DELETE_SUBMITTAL: 28,
    REQUISITION_ORDER: 29,
    EMAIL_REQUISITION_ORDER: 30,
    EXPORT_REQUISITION_ORDER: 31,
    ARCHIVE_REQUISITION_ORDER: 32,
    RESTORE_REQUISITION_ORDER: 33,
    DELETE_REQUISITION_ORDER: 34,
    SUBMIT_REQUISITION_ORDER: 35,
    APPROVE_REQUISITION_ORDER: 36,
    DENY_REQUISITION_ORDER: 37,
    PRICE_FILE_EXPORT: 38,
    PROJECT_ADMINISTRATION: 39,
    ARCHIVE_PROJECT: 40,
    RESTORE_PROJECT: 41,
    SET_DEFAULT_PROJECT: 42,
    VIEW_RELATED_DETAILS_ORDERS_ETC: 43,
    USER_ADMINISTRATION: 44,
    INVOICES_AND_CREDITS: 45,
    VIEW_STATEMENT: 46,
    DOWNLOAD_STATEMENT: 47,
    PAY_BALANCE: 48,
    VIEW_INVOICE: 49,
    EXPORT_INVOICE: 50,
    EMAIL_INVOICE: 51,
    PAY_INVOICE: 52,
    ACCOUNT_INFORMATION: 53,
    USER_DETAILS: 54,
    ASSIGNED_PROJECT_BRANCH: 55,
    COMMUNICATION_PREFERENCES: 56,
    UPDATE_PASSWORD: 57,
    COMPANY_AND_BRANCH_ADMINISTRATION: 58,
    COMPANY_INFORMATION: 59,
    BRANCH_INFORMATION: 60,
    DRILL_CLUB: 61,
    DRILL_CLUB_VIEW_POINTS_BALANCE: 62,
    DRILL_CLUB_VIEW_REWARDS: 63,
    DRILL_CLUB_CLAIM_REWARDS: 64,
    DRILL_CLUB_VIEW_STATEMENT: 65,
    DRILL_CLUB_EXPORT_STATEMENT: 66,
    DRILL_CLUB_EMAIL_STATEMENT: 67,
    ORDERS: 68,
    CHECKOUT_QUOTE: 69,
    CHECKOUT_DRILLCART: 70,
    CHECKOUT_SUBMITTAL: 71,
    CHECKOUT_REQUISITION_ORDER: 72,
    CONVERT_FROM_SUMITALL: 73,
    ADD_TO_CART: 74,
    QUICK_CREATE: 75,
}